@if(goalDetails(); as goal){
<div class="acc-application-overview-content-dialog-part row h-100">
	<div class="bg-light rounded shadow-sm">
		<div class="pt-2 ps-1">
			<h5>
				<span class="badge bg-secondary-subtle text-black px-3 py-2">
					Status: {{goal.status}}
				</span>
			</h5>
		</div>

		<div class="p-2 pt-0">
			<div>
				<div class="d-flex">
					<div class="me-2">Venture:</div>
					<div>{{goal.ventureName}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Category:</div>
					<div>{{goal.category}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Goal Summary:</div>
					<div>{{goal.summary}}</div>
				</div>
			</div>

			<div class="mt-3">
				<div class="d-flex">
					<div class="me-2">Progress Updates:</div>
					<div>{{goal.commentsCountMap.progress}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Latest Progress Update:</div>
					<div>{{goal.latestProgressDate}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Mentor Comments:</div>
					<div>{{goal.commentsCountMap.mentor}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Staff Comments:</div>
					<div>{{goal.commentsCountMap.staff}}</div>
				</div>
			</div>

			<div class="d-flex mt-3">
				<div class="me-2">Goal Details:</div>
				<div>{{goal.details}}</div>
			</div>

			<div class="mt-3">
				<div class="d-flex">
					<div class="me-2">Last Updated By:</div>
					<div>{{goal.updatedByPersonName}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Last Updated On:</div>
					<div>{{goal.formattedUpdatedDate}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Created By:</div>
					<div>{{goal.createdByPersonName}}</div>
				</div>
				<div class="d-flex">
					<div class="me-2">Created On:</div>
					<div>{{goal.formattedCreatedDate}}</div>
				</div>
			</div>
		</div>
	</div>
</div>
}